
<template>
  <div>

    <el-tabs
      tab-position="top"
      style="height: 200px;"
    >
      <el-tab-pane label="好友">
        <Frient01 />
      </el-tab-pane>
      <el-tab-pane label="通讯录">
        <Frient02 />
      </el-tab-pane>
      <el-tab-pane label="邀请记录">
        <Frient03 />
      </el-tab-pane>
    </el-tabs>
    <ApplyFriend
      v-model="applyfriendDailogShow"
      :entity-id="entityId"
      :friend-user-id="friendUserId"
      @save-success="handleSearch2"
    />
    <ShowUpload
      v-model="uploadFormShow"
      :upload-data="uploadData"
      @save-success="handleSearch2"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import ApplyFriend from './applyfriend'
import ShowUpload from './ShowUpload'
import KxjCom from '@/utils/kxjcom'
import Frient01 from './friend01'
import Frient02 from './friend02'
import Frient03 from './friend03'

export default {
  components: {
    ApplyFriend,
    ShowUpload,
    Frient01,
    Frient02,
    Frient03
  },
  props: {},
  data() {
    return {
      title: '我的好友',
      applyfriendDailogShow: false,
      entityId: null,
      friendUserId: null,
      friendData1: [],
      totalCount2: 0,
      friendData2: [],
      friendData3: [],
      allComboxData: [],
      searchForm2: {
        keyWord: '',
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: ''
      },
      uploadData: [],
      uploadFormShow: false,
      // 简历数据
      resumeShow: false,
      resumeUserId: null,
      resumeKey: null
    }
  },
  computed: {},
  watch: {},
  activated() {
    this.$bus.emit('FriendSearch1')
    this.$bus.emit('FriendSearch2')
    this.$bus.emit('FriendSearch3')
    this.handleSearch1() // 搜索好友
    this.handleSearch2() // 搜索非好友
    this.handleSearch3() // 搜索邀请列表
  },
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D04;D07').then(res => {
      this.allComboxData = res.data.result
    })
  },
  mounted() {},
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /** 通讯录 通用 */
    // 每页
    handleSizeChange2(val) {
      this.searchForm2.pageSize = val
      this.handleSearch2()
    },
    // 切页
    handleChangePage2(page) {
      this.searchForm2.pageNumber = page
      this.handleSearch2()
    },
    // 排序
    handleResort2(column) {
      this.searchForm2.sortKey = column.prop
      this.searchForm2.sortOrder = column.order
      this.handleSearch2()
    },
    // 通讯录 新增
    handleAdd() {
      const dataNew = {
        id: null,
        isEdit: true,
        canBeEdit: true
      }
      this.friendData2.unshift(dataNew)
    },

    /** 好友 */
    handleSearch1() {
      const that = this
      that.friendData1 = []
      pathReq
        .getForm('/api/services/app/Contact/GetPagedListContacts1')
        .then(resp => {
          that.friendData1 = resp.data.result.items
        })
    },
    /** 通讯录 */
    handleSearch2() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      that.friendData2 = []
      pathReq
        .getList('/api/services/app/Contact/GetPagedListContacts2', that.searchForm2)
        .then(resp => {
          that.totalCount2 = resp.data.result.totalCount
          that.friendData2 = resp.data.result.items
          loading.close()
        })
    },
    /** 申邀请消息 */
    handleSearch3() {
      const that = this
      that.friendData3 = []
      pathReq
        .getForm('/api/services/app/Contact/GetPagedListContacts3')
        .then(resp => {
          that.friendData3 = resp.data.result.items
        })
    },

    // 编辑
    handleEdit(row) {
      for (var i = 0; i < this.friendData2.length; i++) {
        if (this.friendData2[i].isEdit) {
          if (this.friendData2[i].id) {
            this.friendData2[i].isEdit = false
          } else {
            this.friendData2.splice(i, 1)
            i--
          }
        }
        row.isEdit = true
      }
    },
    // 取消
    handleCancel(row, index) {
      row.isEdit = false
      if (!row.id) {
        this.friendData2.splice(index, 1)
      }
    },
    // 删除
    handleDel(row) {
      const that = this
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/Contact/DeleteContact'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          that.handleSearch2()
        })
      })
        .catch(() => {
        })
    },
    // 新建或修改信息就是保存的时候
    handleSave(row) {
      if (!row.phoneNumber) {
        this.$message.error('请输入手机号码')
        return false
      }
      if (!row.userName) {
        this.$message.error('请输入姓名')
        return false
      }

      const that = this
      var obj = { entityData: row }
      this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/Contact/CreateOrUpdateContact'
      pathReq.postForm(path, obj).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            that.handleSearch2()
          }
        }
      })
    },
    /**
     * 显示课程信息
     */
    handleToDtl(id) {
      this.$router.push({ name: 'contactdtl', params: { id: id }})
    },
    // 导入
    handleBeforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (isLt5M) {
        return true
      }
      this.$message.warning('数据超过5M')
      return false
    },
    handleImportSuccess({ results, header }) {
      const filterVal = [
        'phoneNumber',
        'emailAddress',
        'userName',
        'userName2',
        'sexDictKey',
        'danWeiMingCheng',
        'buMen',
        'keShi',
        'zhiWu',
        'xueWeiDictId',
        'yanJiuLingYu',
        'yanJiuFangXiang'
      ]
      const data = KxjCom.formatJson(header, results)
      var b = []
      for (var i = 0; i < data.length; i++) {
        b.push(KxjCom.formatObj(filterVal, data[i]))
      }
      this.uploadData = b
      for (const row of this.uploadData) {
        row.sexDictKey = KxjCom.getComboxKeyByText(row.sexDictKey, this.getComboxData('D04'))
        row.xueWeiDictId = KxjCom.getComboxKeyByText(row.xueWeiDictId, this.getComboxData('D07'))
      }

      this.uploadFormShow = true
    },

    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '手机号码',
          '电子邮箱',
          '姓名',
          '别名',
          '性别',
          '单位名称',
          '部门',
          '科室',
          '职务',
          '学位',
          '研究领域',
          '研究方向'
        ]
        const filterVal = [
          'phoneNumber',
          'emailAddress',
          'userName',
          'userName2',
          'sexDictKeyItemName',
          'danWeiMingCheng',
          'buMen',
          'keShi',
          'zhiWu',
          'xueWeiDictIdItemName',
          'yanJiuLingYu',
          'yanJiuFangXiang'
        ]
        const list = this._data.friendData2
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '通讯录', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    }
  }
}
</script>

